import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import {
  form,
  FormField,
  FormOptions,
  FormRoot,
  minLength,
  pattern,
  required,
  SchemaPathTree,
  TreeValidationResult,
  validate,
} from '@angular/forms/signals';
import { PasswordVisibilityToggleComponent } from 'src/app/shared/components/password-visibility-toggle/password-visibility-toggle.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FormFieldOnErrorDirective } from 'src/app/shared/directives/form-field-on-error/form-field-on-error.directive';
import { SignalFormService } from 'src/app/shared/services/signal-form/signal-form.service';
import { PASSWORD_PATTERN } from 'src/app/shared/utils/utils';
import { RegisterPasswordStepFormModel } from './register-password-step.model';

@Component({
  selector: 'app-register-password-step',
  templateUrl: './register-password-step.component.html',
  styleUrls: ['./register-password-step.component.scss'],
  imports: [PasswordVisibilityToggleComponent, TranslatePipe, FormField, FormRoot, FormFieldOnErrorDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class RegisterPasswordStepComponent {
  public passwordSubmit = output<string>();
  public back = output<void>();

  public revealPassword = signal(false);

  formModel = signal<RegisterPasswordStepFormModel>({ password: '', confirmPassword: '' });
  formOptions: FormOptions<RegisterPasswordStepFormModel> = SignalFormService.formSubmitOptions(
    this.submitPassword.bind(this),
  );
  form = form(this.formModel, this.#formValidation.bind(this), this.formOptions);

  public togglePasswordVisibility(): void {
    this.revealPassword.set(!this.revealPassword());
  }

  public async submitPassword(): Promise<TreeValidationResult> {
    this.passwordSubmit.emit(this.formModel().password);
    return undefined;
  }

  #formValidation(path: SchemaPathTree<RegisterPasswordStepFormModel>): void {
    required(path.password);
    minLength(path.password, 8);
    pattern(path.password, PASSWORD_PATTERN);

    required(path.confirmPassword);
    minLength(path.confirmPassword, 8);
    pattern(path.confirmPassword, PASSWORD_PATTERN);
    validate(path.confirmPassword, ({ value, valueOf }) => {
      if (value() !== valueOf(path.password)) {
        return { kind: 'passwordMismatch', message: 'Passwords do not match' };
      }
      return null;
    });
  }
}
